@if (formFieldSignal(); as formField) {
    <div class="flex gap-2">
        <kendo-numerictextbox #inputKendo [class.error]="errorState != null || formControl.errors != null"
                              class="h-10 w-full"
                              [ngClass]="{'hidden' : formField.IsHidden  }"
                              [placeholder]="formField.Placeholder"
                              [min]="formField.MinValue"
                              [max]="formField.MaxValue"
                              [readonly]="readOnlyOverride || formField.IsReadOnly"
                              [tabIndex]="readOnlyOverride || formField.IsReadOnly ? -1  : 0"
                              [format]="format(formField)" [value]="nrValue"
                              (valueChange)="onNrValueChange($event)"
                              [spinners]="false"
                              [changeValueOnScroll]="false">
        </kendo-numerictextbox>
        <kendo-combobox #multiSelectInput
                        class="bizz-combobox-multiselect"
                        [class.error]="errorState != undefined"
                        textField="caption"
                        valueField="value"
                        [data]="dateUnitTypes"
                        [listHeight]="400"
                        [clearButton]="false"
                        [readonly]="readOnlyOverride || formField.IsReadOnly"
                        (valueChange)="onUnitTypeChange($event)"
                        [value]="unitTypeValue"
                        [tabIndex]="-1">
        </kendo-combobox>
    </div>
}